import {
  ParamSchemaMode,
  ParamSchemaType,
  ParamValidationType,
} from "@/lib/form/schema"
import { EnumsOf } from "@/lib/utils"

export type PackagingFormSchema = DepartmentSchema[]

export interface PackagingParamSchema {
  type: PackagingParamSchemaType
  name?: string
  list: ParamListItem[]
}

export interface ParamListItem {
  id: string
  name: string
  mode: ParamSchemaMode
  inputTypeExport: ParamSchemaType
  inputTypeDomestic: ParamSchemaType
  validationType?: ParamValidationType
  labelDomestic: string
  labelExport: string
  unitDomestic?: string
  unitExport?: string
  mandatory: boolean
  correctValue?: string
  possibleValues?: (string | ParamListItemPossibleValue)[]
}

export const PackagingParamSchemaType = {
  GENERAL_INFORMATION: "GENERAL_INFORMATION",
  CERTIFICATION: "CERTIFICATION",
  LEAKAGE: "LEAKAGE",
} as const
export type PackagingParamSchemaType = EnumsOf<typeof PackagingParamSchemaType>

export interface ParamListItemPossibleValue {
  id: string
  name: string
  skus: PackagingSKU[]
}

export interface PackagingSKU {
  id: string
  name: string
  code: string
  limits: SKULimit[]
}

export interface SKULimit {
  id: string
  name: string
  minLimit: number
  maxLimit: number
}

export interface PackagingMachineSchema {
  id: string
  name: string
  parameters: PackagingParamSchema[]
}

export interface DepartmentSchema {
  id: string
  name: string
  machines: PackagingMachineSchema[]
}
